import { PositionType, } from "@/common/constants/interfaces";
import { Position } from "@/common/components/FileCenterProvider";

export function isCustomPosition(positionType: PositionType) {
    return (
        positionType === PositionType.LeftTop ||
        positionType === PositionType.LeftBottom ||
        positionType === PositionType.RightTop ||
        positionType === PositionType.RightBottom
    )
}

interface PositionParams {
    position: Position,
    watermarkWidth: number,
    watermarkHeight: number,
    width: number,
    height: number,
    isCollect: boolean,
    ratio: number,
}

export function getPositionLeftTop(params: PositionParams) {
    const {
        position,
        watermarkWidth,
        watermarkHeight,
        width,
        height,
        isCollect,
        ratio,
    } = params
    const { positionType, offsetX, offsetY } = position;

    let offsetLeft = 0;
    let offsetTop = 0;
    if (offsetX === undefined || offsetY === undefined) {
        return { offsetLeft, offsetTop }
    }
    let finalOffsetX = offsetX
    let finalOffsetY = offsetY

    if (isCollect) {
        finalOffsetX = offsetX / ratio
        finalOffsetY = offsetY / ratio
    }

    switch (positionType) {
        case PositionType.LeftTop:
            offsetLeft = finalOffsetX;
            offsetTop = finalOffsetY;
            break;

        case PositionType.RightTop:
            offsetLeft = width - watermarkWidth - finalOffsetX;
            offsetTop = finalOffsetY;
            break;

        case PositionType.RightBottom:
            offsetLeft = width - watermarkWidth - finalOffsetX;
            offsetTop = height - watermarkHeight - finalOffsetY;
            break;

        case PositionType.LeftBottom:
            offsetLeft = finalOffsetX;
            offsetTop = height - watermarkHeight - finalOffsetY;
            break;

        case PositionType.Center:
            offsetLeft = (width - watermarkWidth) / 2;
            offsetTop = (height - watermarkHeight) / 2;
            break;

        case PositionType.Bottom:
            offsetLeft = (width - watermarkWidth) / 2;
            offsetTop = height - watermarkHeight - finalOffsetY;
            break;

        case PositionType.Top:
            offsetLeft = (width - watermarkWidth) / 2;
            offsetTop = finalOffsetY;
            break;

        default:
    }
    return { offsetLeft, offsetTop }
}
